<template>
  <div id="pup" class="popup no-constrain">
    <div class="popup-header">
      <span class="popup-title" id="popup-main-title">Leveringsadresse</span>
    </div>
    <div class="popup-content" id="popup-main-content">
      <div id="pickup-points" class="pickup-points">
       <div id="search">
        <input type="radio" name="country" value="se" v-model="country"> <img src="../assets/se.jpg">
        <input type="radio" name="country" value="dk" v-model="country"><img src="../assets/dk.jpg">
        <input type="radio" name="country" value="no" v-model="country"><img src="../assets/no.jpg">
        <input type="radio" name="country" value="fi" v-model="country"><img src="../assets/fi.jpg">
        <span>Enter Zip</span>
        <input id="map-postal-code" class="map-postal-code" name="MapPostalCode" type="text" pattern="[0-9]*" inputmode="numeric" required="" maxlength="5" minlength="4" value="" v-model="searchTerm">
        <button id="map-postal-code-search" class="button el-button small-button" type="submit" v-on:click="getPups">
          <span class="el-button-text"><span class="text"><span>Search</span></span></span>
          </button>
       </div>
       <div id="map">
         <img v-if="gmaps" :src='gmaps'>
       </div>
       <PuPList v-bind:pups="pups.pickupPoint"/>
      </div>
    </div>
  </div>
</template>

<script>
import PuPList from './puplist'
import axios from 'axios'
export default {
  name: 'pup',
  components: {
    PuPList
  },
  data: function () {
    return {
      gmaps: null,
      searchTerm: '',
      country: '',
      pups: ''
    }
  },
  methods: {
    generatemap: function (points) {
      var url = 'https://maps.googleapis.com/maps/api/staticmap?size=480x480&maptype=roadmap'
      var markers = ''
      for (var i = 0; i < points.length; i++) {
        markers += '&markers=color:red%7C' + points[i].latitude + ',' + points[i].longitude
      }
      url += markers
      url += '&key=AIzaSyAeDHnADobktkuvLHpPtUZfTxUS8y7oDWo'
      return url
    },
    getPups: function () {
      const _t = this
      const s = _t.searchTerm
      const c = _t.country
      if (c.length === 2 && (s.length >= 4 || s.length <= 5)) {
        axios.get('https://elgiganten-bringapi.azurewebsites.net/bring.php?c=' + c.toUpperCase() + '&s=' + s).then(function (resp) {
          _t.pups = resp.data
          _t.gmaps = _t.generatemap(resp.data.pickupPoint)
        })
      }
    }
  }
}

</script>

<style>
#search img{
  height: 40px;
}

div#map {
    width: 49%;
    display: inline-block;
    vertical-align: top;
}

#search span {
    font-size: x-large;
}

.popup .popup-header {
    text-align: center;
    padding: 1em;
}

input#map-postal-code {
    max-width: 150px;
    width: 99.5%;
    padding: 8px;
    margin: 0 auto;
    font-family: sans-serif;
    font-size: 1.1em;
    color: #333;
    background: #fafafa;
    border: 1px solid #ccc;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: inset 0 2px 3px -1px rgba(0,0,0,.3);
    -moz-box-shadow: inset 0 2px 3px -1px rgba(0,0,0,.3);
    box-shadow: inset 0 2px 3px -1px rgba(0,0,0,.3);
    margin: 5px 5px 5px 0;
    display: inline-block;
}

.el-button {
    position: relative;
    display: inline-block;
    padding: .5em .2em;
    background: #7cbd2b;
    color: #333;
    text-align: center;
    min-height: 3.3em;
    font-size: 1em;
    width: 100%;
    min-width: 100px;
    max-width: 300px;
    transition: all 500ms ease;
    text-decoration: none;
    overflow: hidden;
    font-weight: 600;
    box-shadow: 2px 2px 1px rgba(0,0,0,0.15);
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    outline: 0;
    text-shadow: none;
    border: 1px solid transparent;
}
.button {
    font-size: 1em;
    font-weight: bold;
    line-height: 20px;
    text-align: center;
    position: relative;
    color: #fff!important;
    margin: 0 0 2px;
    padding: 6px 12px;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    text-shadow: 1px 1px 3px #666;
    border: 1px solid rgba(0,0,0,.5);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 3px -3px rgba(0,0,0,.5), 0 -1px 1px -1px rgba(0,0,0,.6) inset, 0 2px 1px 0 rgba(255,255,255,.4) inset;
    -moz-box-shadow: 0 1px 3px -3px rgba(0,0,0,.5),0 -1px 1px -1px rgba(0,0,0,.6) inset,0 2px 1px 0 rgba(255,255,255,.4) inset;
    box-shadow: 0 1px 3px -3px rgba(0,0,0,.5), 0 -1px 1px -1px rgba(0,0,0,.6) inset, 0 2px 1px 0 rgba(255,255,255,.4) inset;
    background-color: #8cd600;
    background: -webkit-gradient(linear,0 0,0 100%,from(#8cd600),to(#7ec000));
    background: -moz-linear-gradient(top,#8cd600,#7ec000);
    background: -ms-linear-gradient(top,#8cd600,#7ec000);
    background: linear-gradient(to bottom,#8cd600,#7ec000);
    -ms-filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=#8cd600,endColorStr=#7ec000);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorStr=#8cd600,endColorStr=#7ec000);
}
.el-button.small-button {
    font-size: .8em;
    width:  35px;
}
</style>



// WEBPACK FOOTER //
// src/components/pup.vue